import { createSelector } from 'reselect';

export const dataSelector = state => state.get('performance').get('data');

export const filtersSelector = state => state.get('performance').get('filters');

export const selectedSelector = state => state.get('performance').get('selected');

export const localFiltersUrlParamsSelector = createSelector(
  selectedSelector,
  (selected) => {
    let urlParams = '';

    let owners = selected;
    if (!owners.isEmpty()) {
      urlParams += 'role=';
      owners.map(
        owner =>
          urlParams += owner + ','
      );
      urlParams = urlParams.slice(0, -1);
    }

    return urlParams;
  }
);
